import React from 'react';

import { SETTINGS } from '../setup/config';
import AnimatedPage from './AnimatedPage';
import ContactIntro from '../components/ContactIntro';
import ContentBlock from '../components/ContentBlock';
import ContentBlocks from '../components/ContentBlocks';
import About from '../components/About';
import Separator from '../components/Separator';
import Button from '../components/Button';
import IconLinkedin from '../components/assets/IconLinkedin';
import { ButtonTypes } from '../setup/enum-buttontypes';

function Contact() {
	return (
		<AnimatedPage title={'Contact'}>
			<ContactIntro />
			<Separator type={2} background={'body-background'} />
			<ContentBlocks background={'transparent'} extraClass="contentblocks--inline">
				<div className="columnlayout__column">
					<ContentBlock
						className="contentblocks__contentblock1 contentblock--white"
						content={
							<>
								<h2>Wat kan ik voor u doen?</h2>
								<p>Ik ben dierenarts voor gezelschapsdieren, met een specialisatie in orthomoleculaire therapie voor honden en katten. Mijn interessegebieden liggen binnen de interne diergeneeskunde, voeding, orthomoleculaire therapie en manuele therapieën.</p>
								<p>
									<br />
									Momenteel ben ik beschikbaar voor het uitvoeren van <strong>consulten</strong> en spreekuren binnen (dierenarts)praktijken, het geven van (online) <strong>orthomoleculair voedingsadvies</strong>, en het verzorgen van <strong>workshops</strong> over voeding op locatie. Mijn werkgebied
									voor consulten of workshops op locatie is Noord-Holland (tot ongeveer 45 minuten reistijd vanaf Heemskerk). Voor informatie over mijn beschikbaarheid of samenwerkingsmogelijkheden binnen een praktijk, kunt u contact opnemen per e-mail.
								</p>
								<p>
									<br />
									Bent u <strong>honden- of kattenbaasje</strong> en op zoek naar uitgebreid advies over voeding en suppletie? Dan help ik u graag verder, ook op afstand. U kunt mij per e-mail benaderen met uw vraag. Ik beantwoord deze zo snel mogelijk of stuur u het intakeformulier toe voor een
									passend advies. Op naar gezonde honden en katten!
								</p>
							</>
						}
					/>
				</div>
				<div className="columnlayout__column">
					<ContentBlock
						className="contentblocks__contentblock2"
						content={
							<>
								<h2>Afspraak maken</h2>
								<p>
									Wilt u een afspraak maken voor orthomoleculair voedingsadvies of bent u benieuwd naar mijn beschikbaarheid voor werkzaamheden binnen een praktijk? Neem dan gerust contact met mij op via e-mail. Ik bespreek graag de mogelijkheden met u of stuur u het intakeformulier toe voor een
									voedingsadvies op maat.
								</p>
							</>
						}
					/>
				</div>
			</ContentBlocks>
			<About />
		</AnimatedPage>
	);
}

export default Contact;
